import {Component, Input, OnInit} from '@angular/core';
import {ExgModalService} from 'exc-controls-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcTranslation} from 'exc-core-v2';

@Component({
  selector: 'app-modal-assign-confirmation',
  templateUrl: './modal-assign-confirmation.component.html',
  styles: []
})
export class ModalAssignConfirmationComponent extends ExcTranslation implements OnInit {
  @Input() data: any;
  sendCaseAcceptToClient: boolean = true;

  constructor(
    public modal: ExgModalService,
    public enumSvc: EnumerationService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
  }

  initialize(): void {

  }

  cancel(): void {
    this.modal.close();
  }

  send(rtValue: any): void {
    this.modal.action({assign: rtValue, sendCaseAcceptToClient: this.sendCaseAcceptToClient});
  }

  sendPreDispo(rtValue: boolean) {
    this.modal.action({assign: rtValue, mode: 'preDL'});
  }
}
